export const REACT_QUERY_OPTIONS_NEVER_REFETCH = {
  staleTime: Infinity,
  cacheTime: Infinity,
};

/** `true` only when A and B are the same type, optional modifiers and nested fields included. */
type IsExactly<A, B> =
  (<T>() => T extends A ? 1 : 2) extends <T>() => T extends B ? 1 : 2 ? true : false;

/**
 * Re-types one query's result as another's, e.g. to seed a cache key from a sibling query. Only
 * compiles while the two types are identical, so the queries' selections can't silently drift.
 */
export function asIdenticalResult<To, From extends To>(
  value: From & (IsExactly<From, To> extends true ? unknown : never),
): To {
  return value;
}
